// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"fa36c3ba","475":"fa36c3ba","550":"fa36c3ba","617":"9e983f2b","625":"fa36c3ba","814":"fa36c3ba","864":"fa36c3ba","969":"fa36c3ba"}[chunkId] + ".chunk.css";
};